import { render, staticRenderFns } from "./Admindata.vue?vue&type=template&id=64013e3f&scoped=true"
import script from "./Admindata.vue?vue&type=script&lang=js"
export * from "./Admindata.vue?vue&type=script&lang=js"
import style0 from "./Admindata.vue?vue&type=style&index=0&id=64013e3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64013e3f",
  null
  
)

export default component.exports